import { Component } from "@angular/core";
import { Router } from "@angular/router";
import * as moment from "moment";
import { Globals } from "./globals";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  loading: any;
  config: any = { backdropBorderRadius: '3px' };
  constructor(private router: Router, public globals: Globals) {
    this.router.events.subscribe((val: any) => {
      if (val.url == "/mensaje-financiamiento") {
        this.globals.code_title = 0;
      } else if (val.url == "/datos-solicitante") {
        this.globals.code_title = 1;
      } else if (val.url == "/consulta-tramite") {
        this.globals.code_title = 2;
      } else if (val.url == "/financiamiento-deuda") {
        this.globals.code_title = 3;
      }
    });

    moment.locale("es");
  }
}
